import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '../useApiMutation';
import { operationsClient, apiPost } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { bookingKeys, schedulerKeys } from '@/lib/queryKeys';

export interface BulkRescheduleMove {
  bookingId: string;
  technicianId?: string;
  startAt?: string;
}

export interface BulkRescheduleResult {
  applied: number;
  skipped: number;
  results: { bookingId: string; ok: boolean; error?: string }[];
}

/**
 * §5.7 list bulk action: reassign and/or move a batch of appointments in one
 * call (POST /dispatch/bulk-reschedule). Best-effort server-side — each move is
 * applied independently and the response reports applied / skipped counts.
 */
export function useBulkReschedule() {
  const queryClient = useQueryClient();

  return useApiMutation<BulkRescheduleResult, { moves: BulkRescheduleMove[] }>({
    mutationFn: ({ moves }) =>
      apiPost<BulkRescheduleResult, { moves: BulkRescheduleMove[] }>(
        operationsClient,
        schedulerEndpoints.dispatchBulkReschedule(),
        { moves },
      ),
    showErrorToast: false,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: schedulerKeys.bookings() });
      void queryClient.invalidateQueries({ queryKey: bookingKeys.all() });
    },
  });
}
